var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrossSalarryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0C3.20888 0 2.43552 0.234596 1.77772 0.674121C1.11992 1.11365 0.607234 1.73836 0.304484 2.46927C0.00173313 3.20017 -0.0774802 4.00444 0.0768607 4.78036C0.231202 5.55629 0.612165 6.26902 1.17158 6.82843C1.73099 7.38784 2.44372 7.7688 3.21964 7.92314C3.99556 8.07748 4.79983 7.99827 5.53074 7.69552C6.26164 7.39277 6.88635 6.88008 7.32588 6.22228C7.76541 5.56448 8 4.79112 8 4C8 2.93913 7.57857 1.92172 6.82843 1.17157C6.07828 0.421428 5.06087 0 4 0ZM4 6.28571C3.54793 6.28571 3.10601 6.15166 2.73013 5.9005C2.35424 5.64934 2.06128 5.29236 1.88828 4.8747C1.71528 4.45704 1.67001 3.99746 1.75821 3.55408C1.8464 3.11069 2.0641 2.70342 2.38376 2.38376C2.70342 2.06409 3.1107 1.8464 3.55408 1.7582C3.99747 1.67001 4.45705 1.71527 4.87471 1.88828C5.29237 2.06128 5.64935 2.35424 5.9005 2.73013C6.15166 3.10601 6.28572 3.54793 6.28572 4C6.28572 4.60621 6.0449 5.18759 5.61625 5.61624C5.18759 6.0449 4.60621 6.28571 4 6.28571Z",
    fill: "#145DFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrossSalarryIcon);
export default __webpack_public_path__ + "static/media/GrossSalarryIcon.02a54f9bb3c7be8c16fe383d0f8772d3.svg";
export { ForwardRef as ReactComponent };